'use client';

import { useState } from 'react';

// Location data
const locations = {
  main: {
    id: 'negombo',
    name: 'Ceylon Bike Rent, Negombo',
    query: 'Ceylon Bike Rent, Negombo'
  },
  pickupLocations: [
    { name: 'Mirissa', query: 'Mirissa, Sri Lanka' },
    { name: 'Weligama', query: 'Weligama, Sri Lanka' },
    { name: 'Ella', query: 'Ella, Sri Lanka' },
    { name: 'Hikkaduwa', query: 'Hikkaduwa, Sri Lanka' },
    { name: 'Galle', query: 'Galle, Sri Lanka' },
    { name: 'Unawatuna', query: 'Unawatuna, Sri Lanka' },
    { name: 'Kandy', query: 'Kandy, Sri Lanka' },
    { name: 'Arugam Bay', query: 'Arugam Bay, Sri Lanka' },
    { name: 'Sigiriya', query: 'Sigiriya, Sri Lanka' },
    { name: 'Dambulla', query: 'Dambulla, Sri Lanka' },
    { name: 'Trincomalee', query: 'Trincomalee, Sri Lanka' },
    { name: 'Jaffna', query: 'Jaffna, Sri Lanka' },
    { name: 'Nuwara Eliya', query: 'Nuwara Eliya, Sri Lanka' },
  ]
};

interface LocationMapProps {
  className?: string;
}

export default function LocationMap({ className = '' }: LocationMapProps) {
  const [currentQuery, setCurrentQuery] = useState(locations.main.query);

  const handleLocationChange = (value: string) => {
    if (value === 'negombo') {
      setCurrentQuery(locations.main.query);
    } else {
      const location = locations.pickupLocations.find(
        (loc) => loc.name.toLowerCase().replace(/\s+/g, '-') === value
      );
      if (location) {
        setCurrentQuery(location.query);
      }
    }
  };

  return (
    <div className={`rounded-xl overflow-hidden shadow-lg border border-border/50 flex flex-col relative w-full h-[500px] bg-gray-100 group ${className}`}>

      {/* Map Layer - Static View Centered on Negombo/Airport Midpoint */}
      <div className="absolute inset-0">
        <iframe
          width="100%"
          height="100%"
          style={{
            border: 0,
            filter: 'grayscale(100%) invert(0%) contrast(85%) brightness(105%) sepia(5%)', // Toned down look
            pointerEvents: 'none' // Static background
          }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          // Midpoint visually optimized for 500px height at zoom 12
          src={`https://maps.google.com/maps?ll=7.1951,79.8600&z=12&t=m&hl=en&gl=US&mapclient=embed&q=Negombo&output=embed`}
          title="Location Map"
        />
      </div>

      {/* Overlays Container */}
      <div className="absolute inset-0 pointer-events-none">

        {/* HQ Marker - Visually positioned for 7.2094, 79.8358 relative to center 7.1951, 79.8600 */}
        <div className="absolute top-[35%] left-[35%] -translate-x-1/2 -translate-y-[100%] z-20 drop-shadow-xl animate-scale-in">
          <div className="bg-black text-white py-2 px-4 rounded-lg shadow-md min-w-[170px] text-center transform transition-transform hover:scale-105">
            <div className="text-sm leading-tight mb-0.5">Ceylon Bike Rent, Negombo</div>
            {/* Triangle Pointer */}
            <div className="absolute -bottom-[6px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-black"></div>
          </div>
          {/* Pulse Effect */}
          <div className="absolute -bottom-[10px] left-1/2 -translate-x-1/2 w-16 h-16 bg-black/20 rounded-full animate-pulse-subtle -z-10 blur-xl"></div>
          {/* Shadow */}
          <div className="absolute -bottom-[12px] left-1/2 -translate-x-1/2 w-4 h-1 bg-black/20 rounded-full blur-[2px]"></div>
        </div>

        {/* Airport Marker - Visually positioned for 7.1808, 79.8841 */}
        <div className="absolute top-[60%] left-[62%] -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center group/airport animate-fade-in delay-100">
          <div className="bg-black text-white py-2 px-4 rounded-lg shadow-md min-w-[170px] text-center transform transition-transform hover:scale-105">
            <div className="text-sm leading-tight mb-0.5">Airport (CMB)</div>
            {/* Triangle Pointer */}
            <div className="absolute -bottom-[6px] left-1/4 -translate-x-1/4 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-black"></div>
          </div>
        </div>

      </div>

      <a
        href={`https://www.google.com/maps/search/Sri+Lanka+Bike+Rent,+Negombo`}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute inset-0 z-0 bg-transparent"
        aria-label="Open in Google Maps"
      />
    </div>
  );
}
